import { render, staticRenderFns } from "./ColorTab.vue?vue&type=template&id=fe62427c&"
import script from "./ColorTab.vue?vue&type=script&lang=js&"
export * from "./ColorTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports